import { isValidCompetitorGender } from '../utils/MeetUtils';
import { formatTimeForFilterObject } from '@usas/ui-web/utils/TimesUtils';
import { isValidNumber, isValidBirthDate, isValidSwimTime } from '@usas/ui-web/utils/validation';
import Constants from '@usas/ui-web/utils/Constants';
import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

export const localValidate = (formState) => {
  let errors = {};

  //Athlete 
  if (formState.memberId === '') {
    errors.memberId = 'Athlete is required';
  }

  //Event
  if (formState.eventId === Constants.DEFAULT_ID) {
    errors.eventId = 'Event is required';
  }

  //Session
  if (formState.sessionId === Constants.DEFAULT_ID) {
    errors.sessionId = 'Session is required';
  }

  //Time 
  if (formState.time === '') {
    errors.time = 'Time is required';
  } else if (!isValidSwimTime(formatTimeForFilterObject(formState.time))) {
    errors.time = 'Time must be valid';
  }

  //Place
  if (formState.finishPosition !== '' && (!isValidNumber(formState.finishPosition.trim()) || formState.finishPosition.trim() === '0')) {
    errors.finishPosition = 'Place (finish position) must be a number greater than zero if entered';
  }

  //Event Number
  if (formState.eventNumber !== '' && (!isValidNumber(formState.eventNumber.trim()) || formState.eventNumber.trim() === '0')) {
    errors.eventNumber = 'Event Number must be a number greater than zero if entered';
  }

  if (formState.eventNumber !== '' && parseInt(formState.eventNumber.trim()) > 999) {
    errors.eventNumber = 'Event Number cannot be greater than 999 if entered';
  }

  //Event Age Minimum/Maximum
  if (
      formState.eventAgeMin !== '' && 
      (!isValidNumber(formState.eventAgeMin.trim()) || formState.eventAgeMin.trim() === '0')) {
    errors.eventAgeMin = 'Event Age Minimum must be a number greater than zero if entered';
  }

  if (formState.eventAgeMin !== '' && formState.eventAgeMax !== '' && parseInt(formState.eventAgeMin.trim()) > parseInt(formState.eventAgeMax.trim())) {
    errors.eventAgeMin = 'Event Age Minimum cannot be greater than Event Age Maximum';
  }

  if (formState.eventAgeMax !== '' && parseInt(formState.eventAgeMax.trim()) > 99) {
    errors.eventAgeMax = 'Event Age Maximum cannot be greater than 99 if entered';
  }

  if (formState.eventAgeMax !== '' && (!isValidNumber(formState.eventAgeMax.trim()) || formState.eventAgeMax.trim() === '0')) {
    errors.eventAgeMax = 'Event Age Maximum must be a number greater than zero if entered';
  }

  if (formState.eventAgeMin !== '' && formState.eventAgeMax === '') {
    errors.eventAgeMax = 'Event Age Maximum is required if Event Age Minimum is entered';
  }

  if (formState.eventAgeMax !== '' && formState.eventAgeMin === '') {
    errors.eventAgeMin = 'Event Age Minimum is required if Event Age Maximum is entered';
  }

  //Swim Date
  if (formState.swimDate === '' || formState.swimDateId === Constants.DEFAULT_ID) {
    errors.swimDateId = 'Swim Date is required';
  } else if (!isValidBirthDate(formState.swimDate)) {
    errors.swimDateId = 'Swim Date cannot be in the future'
  }

  if (formState.lscId === Constants.DEFAULT_ID) {
    errors.lscId = 'LSC is required';
  }

  if (formState.clubCode.trim().length === 0) {
    errors.clubCode = 'Club Code is required';
  } else if (formState.clubCode.trim().length > 15) {
    errors.clubCode = 'Club Code cannot exceed 15 characters';
  }

  return errors;
};

export const serverValidate = async (formState) => {
  let errors = {};

  //Member
  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';
  await PersonHttpHelper(`/Person/flat/memberId/${memberIdForUrl}`, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      }
      else {
        formState.personId = objData.personId;
        formState.personGender = objData.competitionGenderTypeId;
      }
    })
    .catch((e) => {
      errors.apiError = 'Member Id is not valid'
    });

  return errors;
}


const AddMeetTimeIndividualValidation = async (formState) => {
  let errors = localValidate(formState);

  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
};

export default AddMeetTimeIndividualValidation;